import classNames from 'classnames';
import ChatMessage, {
  Props as ChatMessageProps
} from '../../Molecules/ChatMessage';

interface Props {
  items: ChatMessageProps[];
  className?: string;
}

function ChatMessageList({ items, className }: Props) {
  return (
    <div
      className={classNames([
        'flex flex-col gap-10',
        className
      ])}
    >
      {items.map((item) => (
        <ChatMessage key={items.indexOf(item)} {...item} />
      ))}
    </div>
  );
}

export default ChatMessageList;
